module.exports = __webpack_public_path__ + "img/wide_toggle.66ad54a2.svg";